import React from 'react';

import Chip from '@mui/material/Chip';

import { ArticleVisibility } from 'stores/ArticleStoreAdapter';

/**
 * 公開設定ごとの色（固定）。
 * master_type ではないためフロントで色を固定する（tech_chip.md 準拠）。
 */
const VisibilityColor: Record<ArticleVisibility, string> = {
  PUBLIC: '#388e3c', // 公開（green）
  INTERNAL: '#1976d2', // 社内公開（blue）
  PRIVATE: '#757575', // 非公開（grey）
};

type Props = {
  visibility: ArticleVisibility;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
  onClick?: () => void;
};

/**
 * 記事の公開設定（PUBLIC / INTERNAL / PRIVATE）を表示するチップ。
 */
const VisibilityChip: React.FC<Props> = ({
  visibility,
  size = 'small',
  variant = 'outlined',
  onClick,
}) => {
  const color = VisibilityColor[visibility];

  return (
    <Chip
      label={ArticleVisibility[visibility]}
      size={size}
      variant={variant}
      onClick={onClick}
      sx={{
        color: variant === 'outlined' ? color : '#fff',
        borderColor: color,
        backgroundColor: variant === 'filled' ? color : undefined,
        cursor: onClick ? 'pointer' : 'default',
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default VisibilityChip;
